import React from 'react';
import { IconBase } from '../Base';
export const IconDebit = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M3.5 14L5.5 16L7.5 14", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M11.5 2.75V13M11.5 13L6.5 8M11.5 13L16.5 8", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round" })));
};
//# sourceMappingURL=Debit.js.map